import * as React from "react";
import type { SVGProps } from "react";
const SvgHouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20 22h-6c-.55 0-1-.45-1-1v-5h-2v5c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V9c0-.31.15-.61.4-.8l8-6a.99.99 0 0 1 1.2 0l8 6c.25.19.4.49.4.8v12c0 .55-.45 1-1 1m-5-2h4V9.5l-7-5.25L5 9.5V20h4v-5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1z"
    />
  </svg>
);
export default SvgHouse;
